<!--
<div class="panel panel-default" *ngIf="product">
    <div class="panel-body" style=" border: #9b7544 2px solid; padding:5px ">
        <div class="card" style="padding: 5px; margin:5px; background:#9b7544; color:#fff">
        <div class="row">
            <div class="col-4  text-center">
                <label >Search Name <input type="text" 
                      [(ngModel)]="searchproduct" ></label>   
            </div>
            
            <div class="col-4  text-center" *ngIf="data2">
                <label>Search  Brand<select  [(ngModel)]="searchbrand" >
                    <option *ngFor="let b of data2" value="{{b.id}}">{{b.name}}</option>
                </select>
                </label> 
              </div>
            <div class="col-2  text-center" *ngIf="food.length>0">
              <button class="btn btn-default btn-sm" (click)="confirmFood()">Confirm</button>
            </div>
            <div class="col-2  text-center" *ngIf="searchbrand||searchproduct">
                <button class="btn btn-danger btn-sm" (click)="clearFilter()">Clear</button>
              </div>
            </div>
          </div>
  
          <div   style="height: 550px !important ; overflow: scroll;margin: 10px">
              <table class="table table-bordered" >
                  <thead>
                    <th></th>
                    <th>Name</th>
                    <th>Price</th>
                    <th>Special Price</th>
                  </thead>
              <tbody>
                <tr *ngFor="let p of product " 
                style="border-bottom:#9b7544 2px solid">
                  <td><img src="https://passport.petcart.in/images/prodimgs/{{p.image}}"
                     style="width:50px;height:50px"></td>
                <td >
                  {{p.name}}
                </td>
                <td>
                    {{p.price}}
                  </td>
                  <td>
                      {{p.splprice}}
                </td>
                <td>
                  <input type="checkbox" style="margin:10px" [ngModel]="p.checked"
                  [disabled]="isAlreadyAdd(p.name)"
                  (change)='addFood($event, p.id,p.price,p.splprice,p.name)'>
                </td>
              </tr> 
            </tbody>
          </table>
          </div>
       
    </div>
  </div> -->

  <ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>
  <div *ngIf="flag == 0">
    <div style="margin-left: 15%"> <h2 style="color: #9b7544; font-size: 40px"><u style="margin-left: 72px;"> Select Food Type</u> </h2> </div>
    <div class='row' style="margin-top: 20%; margin-left: 30%">
      <h2 style="color: #9b7544; font-size: 40px; margin-left: 40px;" (click)="check(1,'Dog')">Dog Food </h2>
  </div>
 
      <div class='row' style="margin-top: 10%; margin-left: 30%">
          <h2 style="color: #9b7544; font-size: 40px;  margin-left: 50px;" (click)="check(2,'Cat');">Cat Food </h2>
      </div>

  </div>
  <div *ngIf="flag == 1">
      <div class="card" style="padding: 5px; margin:5px; background:#9b7544; color:#fff">
          <div class="row">
                <div class="col-4  text-center">
                        <button class="btn btn-default btn-sm" (click)="back()">Back</button>
                    </div>
              <div class="col-4  text-center">
                 
              </div>
           
           
              <div class="col-4  text-center">
                
                  <button class="btn btn-default btn-sm" (click)="cancel2()">Close</button>
              </div>
            
              </div>
            </div>
  <div  *ngIf="similarcat && similarcat.length>0">
    

    
              <div *ngIf="id == 1">
                 <img  (click)="goToSimilarProduct1(5, 'Food');" class="dogcatg" src="https://petcart.in/mobassets/dogcatg1.jpg">
                  <img  (click)="goToSimilarProduct1(6, 'Treats');" class="dogcatg" src="https://petcart.in/mobassets/dogcatg2.jpg">
                   <img  (click)="goToSimilarProduct1(7, 'Supplies');" class="dogcatg" src="https://petcart.in/mobassets/dogcatg3.jpg">
    
    
    
              </div>

              <div *ngIf="id == 2">
                  <img  (click)="goToSimilarProduct1(8, 'Food');" class="catcatg" src="https://petcart.in/mobassets/catcatg1.jpg">
                   <img  (click)="goToSimilarProduct1(9, 'Treats');" class="catcatg" src="https://petcart.in/mobassets/catcatg2.jpg">
                    <img  (click)="goToSimilarProduct1(11, 'Supplies');" class="catcatg" src="https://petcart.in/mobassets/catcatg3.jpg">
                    <img  (click)="goToSimilarProduct1(10, 'Litter and Accessories');" class="catcatg" src="https://petcart.in/mobassets/catcatg4.jpg">
     
     
     
               </div>
        
    
                </div>
  </div>

  <div *ngIf="flag == 2"> 
      <div class="card" style="padding: 5px; margin:5px; background:#9b7544; ">
          <div class="row">
              <div class="col-sm-12 col-lg-4 col-xl-4 text-center">
                  <label >Search Name <input type="text" [(ngModel)]="searchproduct" ></label>   
              </div>
          
           
             <div class="col-sm-12 col-lg-4 col-xl-4  text-center">
                <button class="btn btn-success2"  *ngIf="food.length>0"  (click)="confirmFood()">Confirm Selection</button>
              </div> 
              <div class="col-sm-12 col-lg-4 col-xl-4  text-center" style="margin-top:10px">
                  <button class="btn btn-default btn-sm" (click)="cancel1()">Back</button>
              </div>
            
              </div>
            </div>
      <div class="row" *ngIf="data && data.length>0 " style="margin-top:40px;">
        <div class="col-sm-12 col-lg-4 col-xl-4 text-center" *ngFor="let data1 of data | productnamefilter: searchproduct">
          <div class="prodgrid" style="box-shadow:0 1px 4px rgba(0, 0, 0, .5);
           margin-right:10px; margin-bottom:10px;">
           <div class="card">
             <div style="width:100%;text-align: center; cursor: pointer">
               <img style="height: 250px; width:100%" class="card-img-top-prod" src="https://passport.petcart.in/images/prodimgs/{{data1.image}}" alt="Card image">
           </div>
         </div>
           <div class="card-body" style="height:150px ; border: 1px solid;     padding: 5px !important;  background-color:#fff; cursor: pointer">
             <div style="min-height:90px;" >
             <span style="font-style:open sans; color: #9b7544;  overflow-wrap: break-word;">
                <h5 style="font-size: 14px;">{{ data1.name }}</h5>
             </span>
             <span style="font-style: open sans; color: #cb983f; font-size:16px;  font-weight:bold;  overflow-wrap: break-word" *ngIf="data1.splprice === 0; ">
                 Rs. {{ data1.price }}
             </span>
                 <p style="font-style: open sans; color: #cb983f; margin-bottom: 0px !important;
                 overflow-wrap: break-word;  font-size:15px" *ngIf="data1.splprice > 0;">
                 <del style="color:#c5c5c5">Rs. {{ data1.price }}</del>
                 <span style="font-size:15px; float:right;">Rs. {{ data1.splprice }}</span>
                 
               
                   
                </p><br>
                <button   (click)="addedFood(data1.id, data1.price, data1.splprice, data1.name)"    class="cartbtn" style="margin-top: 3px">
                    <i class="material-icons" >&#xE8CC;</i>Add</button>
               </div>
                 <div class="row">
                 
                  </div>
           </div>
   
          </div>
        </div>
  </div>
  </div>